import React, { Component } from 'react';
export default class Joinpeople extends Component {
    render() {
        return (
            <section class="mystory-join">
                <h1 class="section-head"> Join people already <br></br>using MyyShopp </h1>
            </section>
        )
    }
}